import React, { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { createData } from "../../utility/adminApi";
import LineChart from "../../components/LineChart";

function LowstockChart() {
  const [newPeriod] = useState({ data_filter: "12months" });
  const [dataSet, setDataset] = useState({});

  const chartData = useMutation({
    mutationFn: (newPeriod) =>
      createData(`dashboard/low-stock?date_filter=${newPeriod.data_filter}`, null, true),
    onSuccess: (data) => {
      console.log(data);
      setDataset(data?.data);
    },
  });
  useEffect(() => {
    chartData.mutate(newPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col h-full min-w-0 bg-white rounded-lg gap-4 sm:gap-6 p-3 sm:p-4">
      <div className="flex justify-between">
        {" "}
        <h3 className="text-xl sm:text-2xl font-medium"> Stock Level</h3>
        <div>
          {/* <SelectLabels
            valueKey="id"
            labelKey="key"
            text="Select Period"
            categoryData={period}
            onSelectChange={handleChange}
            previousValue={defaultNum}
          /> */}
        </div>
      </div>
      {/* Replace with chart library like Chart.js */}

      <LineChart rawData={dataSet} />
    </div>
  );
}

export default LowstockChart;
